import ApplicationPaginatedResource from './ApplicationPaginatedResource';
import glue from "../glue";
export var PageStatus;
(function (PageStatus) {
    PageStatus["DRAFT"] = "DRAFT";
    PageStatus["REVIEW"] = "REVIEW";
    PageStatus["PUBLISHED"] = "PUBLISHED";
    PageStatus["UNPUBLISHED"] = "UNPUBLISHED";
})(PageStatus || (PageStatus = {}));
export default class AdminPageResource extends ApplicationPaginatedResource {
    constructor() {
        super(...arguments);
        this.id = '';
        this.title = 'Nouvelle page sans titre';
        this.status = PageStatus.DRAFT;
        this.website = glue.websites[0].code;
    }
    pk() {
        return this.id;
    }
}
AdminPageResource.resource = '/admin/pages';
//# sourceMappingURL=AdminPageResource.js.map